module.exports = __webpack_public_path__ + "static/media/marker.6a0c8204.svg";